import React from 'react';
import { Chip } from '@mui/material';
import { ServiceCallStatus } from 'modules/service-call/types';
import { useIntl, defineMessages, MessageDescriptor } from 'react-intl';

interface StatusChipProps {
  status: ServiceCallStatus
}

const serviceCallStatusChipColor: Record<ServiceCallStatus, 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | undefined> = {
  [ServiceCallStatus.InProgress]: 'primary',
  [ServiceCallStatus.Resolved]: 'secondary'
};

export const serviceCallStatusMessageDescriptors: Record<ServiceCallStatus, MessageDescriptor> =
  defineMessages({
    [ServiceCallStatus.InProgress]: { id: 'ServiceCallInformation.InProgress', defaultMessage: 'In progress' },
    [ServiceCallStatus.Resolved]: { id: 'ServiceCallInformation.Resolved', defaultMessage: 'Resolved' }
  });

export const StatusChip: React.FC<StatusChipProps> = ({ status }) => {
  const { formatMessage } = useIntl();

  return (
    <Chip size='small' color={serviceCallStatusChipColor[status]} label={formatMessage(serviceCallStatusMessageDescriptors[status])} />
  );
};